$(document).on("turbolinks:load", function () {
  var $refundForm = $(".js-adminRefund-form")

  if ($refundForm.length > 0) {
    var $checkboxes = $refundForm.find(".js-adminRefund-product")
    var $status = $refundForm.find(".js-adminRefund-status")
    var $total = $refundForm.find(".js-adminRefund-total")

    var updateTotal = function () {
      var cents = 0
      $checkboxes.filter(":checked").each(function () {
        cents += parseInt($(this).data("amount"), 10) || 0
      })
      $total.text("$" + (cents / 100).toFixed(2))
    }

    $status.on("change", function () {
      if ($(this).val() == "refunded") {
        $checkboxes.not(":disabled").prop("checked", "true")
        updateTotal()
      }
    })

    $checkboxes.on("change", updateTotal)
    updateTotal()
  }

  $refundForm.on("submit", function () {
    $("body")
      .addClass("loading")
      .prepend('<div class="loading-messages">Processing Refund ...</div>')
  })
})
